import { Theme, ThemeDefinition } from '@omegagrid/core';

export const tmReportingDark: Theme = {
	name: 'rp-dark',
	type: 'dark',
	accentColor: '#5ec7d1',
	definition: {
		'base-shadow': '0 4px 10px rgba(0,0,0,0.6)',
		'button-color': 'var(--og-accent-color)',
		'button-background-color': '#212a3a',
		'button-background-color-highlight': '#2e3a4e',
		'background-color': '#0f1117',
		'background-color-2': '#161a22',
		'background-color-3': '#1e2330',
		'text-highlight-color': '#5ec7d1',
		'text-color': '#8b949e',
		'text-color-2': '#e1e4e8',
		'text-color-3': '#e1e4e8',
		'text-color-reversed': '#ffffff',
		'border': '#2a3040',
		'border-color': '#2a3040',
		'border-color-2': '#1e2330',
		'border-color-3': '#4a5568',
		'cell-background': '#161a22',
		'cell-border': '1px solid #2a3040',
		'hcell-background': '#1e2330',
		'slider-background-color': '#1a1e28',
		'slider-background-active': '#232938',
		'slider-bar-color': '#3a4258',
		'slider-bar-active': '#3a4258',
		'expander-color': '#5a6577',
		'expander-hover': '#5ec7d1',
		'expander-background-color': '#2a3040',
		'sizer-background': '#5ec7d1',
		'frozen-border': '#0a0c10',
		'inset-shadow-color': '#0a0c10',

		'commands-color': '#e1e4e8',
		'commands-background': '#0f1117',
		'commands-header-background': '#1e2330',
		'commands-input-background': '#131620',
		'commands-shadow': '#0a0c10',

		'dialog-color': '#e1e4e8',
		'dialog-background': '#0f1117',
		'dialog-header-background': '#1e2330',
		'dialog-shadow': '#0a0c10',

		'tab-border-color': '#1e2330',
		'tab-background-color': '#0f1117',
		'tab-panel-background-color': '#0f1117',
		'tab-background-color-active': '#161a22',

		'bucket-tab-background-color': '#1e2330',
		'bucket-tab-panel-background-color': '#161a22',
		'bucket-tab-background-color-active': '#161a22',
		'bucket-right-background-color': '#161a22',
		'bucket-border-color': '#1e2330',
		'bucket-center-background-color': '#0f1117',
		'bucket-left-background-color': '#0f1117',
		'bucket-top-background-color': '#0f1117',
		'bucket-sidebar-background-color': '#1a1e28',

		'form-background-color': '#232938',

		'colortype-yellow-background-color': '#c4892e',
		'colortype-yellow-border-color': '#9a6b20',
		'colortype-yellow-text-color': '#ffffff',

		'colortype-green-background-color': '#2a7a5a',
		'colortype-green-border-color': '#1e5c42',
		'colortype-green-text-color': '#ffffff',

		'colortype-red-background-color': '#9e3038',
		'colortype-red-border-color': '#7a2028',
		'colortype-red-text-color': '#ffffff',

		'colortype-blue-background-color': '#2a6aaa',
		'colortype-blue-border-color': '#1e5088',
		'colortype-blue-text-color': '#ffffff',

		'colortype-gray-background-color': '#2a3040',
		'colortype-gray-border-color': '#1e2330',
		'colortype-gray-text-color': '#e1e4e8',

		'colortype-accent-text-color': '#ffffff',

		'switch-background-color': '#2a3040',
		'switch-slider-color': '#e1e4e8',

		'code-background-color': '#161a22',

		'highcharts-title-font-size': '16px',
		'highcharts-subtitle-font-size': '14px',

		/* Colors for data series and points */
		'highcharts-color-0': '#5ec7d1',
		'highcharts-color-1': '#6a7ecc',
		'highcharts-color-2': '#4abf8a',
		'highcharts-color-3': '#d4895a',
		'highcharts-color-4': '#7a9cc4',
		'highcharts-color-5': '#b87ad8',
		'highcharts-color-6': '#45c4b8',
		'highcharts-color-7': '#cc6e6a',
		'highcharts-color-8': '#d4a870',
		'highcharts-color-9': '#82b8b4',

		'highcharts-background-color': '#161a22',

		/*
			Neutral color variations — blue-tinted grays
			https://www.highcharts.com/samples/highcharts/css/palette-helper
		*/
		'highcharts-neutral-color-100': '#e1e4e8',
		'highcharts-neutral-color-80': '#b8c0cc',
		'highcharts-neutral-color-60': '#8b949e',
		'highcharts-neutral-color-40': '#5a6577',
		'highcharts-neutral-color-20': '#3a4258',
		'highcharts-neutral-color-10': '#2a3040',
		'highcharts-neutral-color-5': '#1e2330',
		'highcharts-neutral-color-3': '#1a1e28',

		/* Highlight color variations — teal-tinted */
		'highcharts-highlight-color-100': '#5ec7d1',
		'highcharts-highlight-color-80': '#4aa8b4',
		'highcharts-highlight-color-60': '#3a8a98',
		'highcharts-highlight-color-20': '#1e3a42',
		'highcharts-highlight-color-10': '#162830',
	},
};
